import querystring from 'querystring';
import { selector } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { user } from '../atoms/user';

import { agentUserId } from '../atoms/agentUserId';
import { numberToBuy } from '../atoms/numberToBuy';

export const buyPhoneNumber = selector({
  key: 'buyPhoneNumber',
  get: async ({ get }) => {
    try {
      // subscribed to team name atom that is created upon submition of team name change
      const formData = get(numberToBuy);
      const storageUser = get(user);
      const currentUser = get(agentUserId);
      if (formData.number.length) {
        const requestBody = {
          call: 'buyphonenumberany',
          businessid: storageUser.businessid,
          country: formData.country,
          userid: currentUser.id,
          apiKey: storageUser.apikey,
          targetid: currentUser.id,
          destinationType: 'user',
          number: formData.number,
          rate: formData.rate,
          numType: formData.numType,
          role: storageUser.user?.role,
        };
        const stringed = querystring.stringify(requestBody);
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          withCredentials: true,
        };
        const url = `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`;
        const result = await axios.post(url, stringed, config);
        return result;
      } else {
        const result = [];
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
